
export class EventDataModel {
/**
 * <p> Holds the data of the event emitted.</p>
 */
data: any;
/**
 * <p> Holds the name of the source that emitted the event.</p>
 */
source: string;
/**
 * <p> the tage of the source component in case of multiple instances. </p>
 */
sourceTag: string;
/**
 * It is the constructor for the EventDataModel
 * @param {?=} values
 */
constructor(values: Object = {}) {
    Object.assign(this, values);
  }

}

function EventDataModel_tsickle_Closure_declarations() {
/**
 * <p> Holds the data of the event emitted.</p>
 * @type {?}
 */
EventDataModel.prototype.data;
/**
 * <p> Holds the name of the source that emitted the event.</p>
 * @type {?}
 */
EventDataModel.prototype.source;
/**
 * <p> the tage of the source component in case of multiple instances. </p>
 * @type {?}
 */
EventDataModel.prototype.sourceTag;
}

